import { useQuery } from '@tanstack/react-query';

import { axiosManager } from '@/api/api-client';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Loading } from '@/components/shared/loading';

export const BusinessLogo = ({ model }: { model?: string }) => {
  const {
    data: logoUrl,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['business-logo'],
    queryFn: () => fetchLogoBusiness(model!),
    enabled: !!model,
    retry: 1,
  });

  if (isLoading)
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loading variant="inline" label="Loading logo..." />
      </div>
    );
  if (isError) return <p>Error: loading logo</p>;

  return logoUrl ? (
    <img src={logoUrl} className="h-full w-full object-contain" alt="Business Logo" />
  ) : (
    <Avatar className="h-full w-full">
      <AvatarImage src={'/images/profile/business.jpg'} />
      <AvatarFallback>doitpay</AvatarFallback>
    </Avatar>
  );
};

const fetchLogoBusiness = async (logoPath: string): Promise<string> => {
  const cacheBuster = new Date().getTime();

  const imgRes = await axiosManager.httpWithAuth.get<ArrayBuffer>(
    `dashboard/v1/public/file/read?file_path=${logoPath}&_=${cacheBuster}`,
    { responseType: 'arraybuffer' },
  );

  const arrayBufferView = new Uint8Array(imgRes.data);
  const blob = new Blob([arrayBufferView], {
    type: imgRes.headers['content-type'],
  });
  return URL.createObjectURL(blob);
};
